<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" width="80%">
      <v-card>
        <v-card-title>
          <span class="text-h5">Ayuda</span>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" icon text @click="emitDialogClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list subheader two-line>
            <div v-for="(item, index) in lista" :key="index">
              <v-subheader v-if="item.Dato != ''" style="font-weight: bold; color: var(--v-anchor-base)">{{ item.Dato
              }}</v-subheader>
              <v-list-item>
                <v-list-item-avatar v-if="item.Icono != '' && item.ID != 10 && item.ID != 11">
                  <v-btn fab dark small :color="item.Color" v-if="(item.ID != 7 && item.ID != 8 && item.ID != 9)"
                    style="cursor: auto;">
                    <v-icon dark> {{ item.Icono }} </v-icon>
                  </v-btn>
                  <v-btn fab dark small :color="item.Color" v-else style="cursor: auto;" readonly>
                  </v-btn>
                </v-list-item-avatar>
                <div v-if="item.Icono == '' && item.ID != 10 && item.ID != 11" :style="{ borderColor: item.Color }"
                  style="height: 40px; min-width: 40px; width: 40px; border-left-style:solid; border-left-width:4px;">
                </div>
                <div v-if="item.Icono != '' && (item.ID == 10 || item.ID == 11)" :style="{ color: item.Color }"
                  class="mr-1"
                  style="height: 40px; min-width: 40px; width: 40px; font-weight: bold; display: grid; align-content: center;">
                  {{ item.Icono }}
                </div>
                <v-list-item-content>
                  <v-list-item-title id="texto">
                    {{ item.Descripcion }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </div>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" text @click="emitDialogClose()">
            CERRAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Lideres from "@/services/Lideres/Lideres.service.js";

export default {
  name: "LideresHelpDialog",
  data() {
    return {
      dialog: true,
      lista: []
    };
  },
  async mounted() {
    this.lista = await Lideres.AyudaLideres();
  },
  methods: {
    emitDialogClose() {
      this.$emit("dialogCloseEvent", false);
    },
  },
  watch: {
    'dialog'(val) {
      if (val == false) {
        this.$emit("dialogCloseEvent", false);
      }
    }
  }
};
</script>

<style>
.help-dialog-style {
  width: 70% !important;
  min-width: 340px !important;
}


#texto {
  white-space: normal;
  overflow-wrap: break-word;

}
</style>
